<template>
  <CategoryForm :element="category" :onSubmit="submit"></CategoryForm>
</template>

<script>
import CategoryForm from './category-form.vue';
import { busEvent } from '../events/bus';
import { CategoryModel } from '../../store/category-module';

export default {
  name: 'CreateCategory',
  components: {
    CategoryForm,
  },
  data: () => ({
    category: { ...CategoryModel },
  }),
  methods: {
    submit() {
      const store = this.$store;
      store.dispatch('category/create', {
        appId: this.$route.params.appId,
        body: this.category,
      })
        .then((category) => {
          busEvent.$emit('succesPopupCreated', 'Category created');
          this.$router.push({
            name: 'Edit Category',
            params: {
              appId: this.$route.params.appId,
              categoryId: category.id,
            },
          });
        });
    },
  },
};
</script>
